import { FC, useState } from 'react';
import styled from 'styled-components';
import CheckIcon from './icons/Check';
import CopyIcon from './icons/Copy';

const Container = styled.div`
  display: flex;
  align-items: center;
  color: var(--primary-600);
  stroke: var(--primary-600);
  svg {
    width: 0.8rem;
    max-height: 1rem;
    margin-left: 0.3rem;
  }
`;

type Props = {
  text: string;
  copiedText?: string;
};
const CopyText: FC<Props> = ({ text, copiedText, ...props }) => {
  const [copied, setCopied] = useState(false);
  const handleCopy = () => {
    setCopied(true);
    setTimeout(() => setCopied(false), 1000);
  };
  return (
    <Container
      onClick={() => {
        handleCopy();
        navigator.clipboard.writeText(copiedText || text);
      }}
      {...props}
    >
      {text}
      &nbsp;
      {copied ? <CheckIcon /> : <CopyIcon />}
    </Container>
  );
};

export default CopyText;
